import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { camelToSnakeCase } from '@valg-shared/utils/string-utils';

export type EnumValueType = string | number | symbol;
export type EnumType = { [key in EnumValueType]: EnumValueType };
@Injectable({
  providedIn: 'root',
})
export class EnumService {
  constructor(private readonly translate: TranslateService) {}

  public translateValue(value?: string, enumName?: string, param?: object): string {
    if (!value || !enumName) {
      return '';
    }
    const key = `enums.${camelToSnakeCase(enumName)}.${camelToSnakeCase(value)}`;

    const translation = this.translate.instant(key, param);
    return translation !== key ? translation : value;
  }

  public translateValues(values: string[], enumName?: string, param?: object): string[] {
    if (!values || !enumName) {
      return [];
    }

    const translatedValues: string[] = [];
    const enumNameSnakeCase = camelToSnakeCase(enumName);

    values.forEach((value) => {
      const key = this.getEnumKey(enumNameSnakeCase, value);
      translatedValues.push(this.getTranslatedValue(key, value, param));
    });

    return translatedValues;
  }

  public translateValuesWithParams(values: string[], params: object[], enumName?: string, ): string[] {
    if (!values || !enumName) {
      return [];
    }

    const translatedValues: string[] = [];
    const enumNameSnakeCase = camelToSnakeCase(enumName);

    values.forEach((value) => {
      const key = this.getEnumKey(enumNameSnakeCase, value);
      const param = params.filter(x => (x as any)[value] !== undefined)[0];
      translatedValues.push(this.getTranslatedValue(key, value, param));
    });

    return translatedValues;
  }

  private getEnumKey(enumNameSnakeCase: string, value: string){
    return `enums.${enumNameSnakeCase}.${camelToSnakeCase(value)}`;
  }

  private getTranslatedValue(key: string, value: string, param: object|undefined){
    const translation = this.translate.instant(key, param);
    return translation !== key ? translation : value;
  }

  public toInputDropdownList<T>(values: (EnumValueType & T)[], enumName: string): { label: string, value: T }[]
  {
    return values.map(value => {
      return {
        label: this.translateValue(value.toString(), enumName),
        value: value
      }
    });
  }
  public enumItemToInputDropdownList<T>(enumType: EnumType) : { label: string, value: T }[]
  {
    return Object.values(enumType).map(e => {
      return {
        label: this.translateValue(enumType[e as keyof T].toString(), enumType.toString()),
        value: enumType[e as keyof T] as unknown as T
      }
    });
  }
}
